/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Calendar_Quota_Notice_Consumes_Week_FirstInputs */

const fr_calendar_quota_notice_consumes_week_first = /** @type {(inputs: Calendar_Quota_Notice_Consumes_Week_FirstInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utilise 1 séance — ${i?.day} deviendra ta 1ʳᵉ séance de la semaine`)
};

/**

* @param {Calendar_Quota_Notice_Consumes_Week_FirstInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_notice_consumes_week_first = /** @type {((inputs: Calendar_Quota_Notice_Consumes_Week_FirstInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Notice_Consumes_Week_FirstInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_notice_consumes_week_first(inputs)
});